import FilterButton from "common/components/ui/FilterButton";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectItemText,
  SelectTrigger,
  SelectValue,
} from "common/components/ui/Select";

interface UrlColumnSelectProps {
  urlColumn: string;
  options: string[];
  onSelect: (value: string) => void;
}

export default function UrlColumnSelect({
  urlColumn,
  options,
  onSelect,
}: UrlColumnSelectProps) {
  return (
    <div className="grid grid-cols-2 items-center gap-x-4">
      <span className="text-sm-bold text-black-700">Main identifier:</span>

      <Select value={urlColumn} onValueChange={onSelect}>
        <SelectTrigger asChild>
          <FilterButton className="w-28 lg:w-32">
            <SelectValue />
          </FilterButton>
        </SelectTrigger>

        <SelectContent>
          {options.map((option) => (
            <SelectItem value={option} key={option}>
              <SelectItemText>{option}</SelectItemText>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
